import { render, staticRenderFns } from "./OffersDetailPopin.vue?vue&type=template&id=67187fc4&scoped=true"
import script from "./OffersDetailPopin.vue?vue&type=script&lang=js"
export * from "./OffersDetailPopin.vue?vue&type=script&lang=js"
import style0 from "./OffersDetailPopin.vue?vue&type=style&index=0&id=67187fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67187fc4",
  null
  
)

export default component.exports